<template>
  <a
    :style="buttonElStyles"
    :target="button.link.target?.value || '_self'"
    :href="isExternalLink ? button.link.url : internalLink"
    class="cta-button"
    @click="$emit('emittedClick')"
  >
    <span class="cta-text">
      {{ button.text }}
    </span>

    <span class="cta-icon-container">
      <IconChevronRight :fill="button.textColor.value" />
    </span>
  </a>
</template>

<script>
import IconChevronRight from "../Icons/IconChevronRight.vue";
import { buttonComputed } from "./mixins/button.js";

export default {
  name: "GlobalUICtaButton",
  components: {
    IconChevronRight,
  },
  mixins: [buttonComputed],
  props: {
    ctaButton: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    button() {
      // Used for backwards compatibility
      return this.ctaButton;
    },
    isExternalLink() {
      return this.button.link.type.value === "external";
    },
    internalLink() {
      // Making it compatible with SPA in RH and SSR in NCF
      if (process.server) {
        return `#${this.button.link.scrollTarget.value}`;
      } else {
        return `${window.location.pathname}${window.location.search}#${this.button.link.scrollTarget.value}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-button {
  --cta-button-padding-x: 30px;
  --icon-width: 8px;
  --icon-padding-left: 11px;
  --icon-move-right: calc(
    var(--cta-button-padding-x) - (var(--icon-padding-left) + var(--icon-width))
  );
  --button-border-radius: 50px;

  cursor: pointer;

  position: relative;

  display: inline-flex;

  padding-block: 17px;
  padding-inline: var(--cta-button-padding-x);

  font-style: normal;
  color: var(--text-color);
  text-decoration: none;
  overflow-wrap: anywhere;

  border: 1px solid rgb(0 0 0 / 3%);
  box-shadow:
    0 1px 2px 0 rgb(0 0 0 / 5%),
    0 4px 12px 0 rgb(0 0 0 / 5%);

  transition: box-shadow 0.15s ease-in-out;

  @include font-family("button");
  @include scale-fonts("button");

  @include laptop {
    --cta-button-padding-x: 28px;
    --icon-padding-left: 10px;

    padding-block: 16px;
  }

  @include tablet {
    --cta-button-padding-x: 25px;
    --icon-padding-left: 8px;

    padding-block: 15px;
  }

  @include mobile {
    --cta-button-padding-x: 20px;
    --icon-padding-left: 6px;

    padding-block: 10px;
  }

  .cta-text {
    transition: all 0.3s ease-in-out;
  }

  .cta-icon-container {
    position: absolute;
    top: 50%;
    right: var(--icon-move-right);
    transform: translateY(-50%);

    display: inline-block;

    width: max-content;
    height: max-content;
    padding-left: var(--icon-padding-left);

    opacity: 0;

    transition: all 0.3s ease-in-out;
  }

  svg#icon-chevron-right {
    width: var(--icon-width);

    @include tablet {
      height: 12px;
    }

    @include mobile {
      height: 11px;
    }
  }

  &:hover {
    box-shadow:
      0 2px 4px 0 rgb(0 0 0 / 18%),
      0 4px 12px 0 rgb(0 0 0 / 5%);

    --move-left: -6px;

    .cta-icon-container {
      transform-origin: left;
      transform: translateY(-50%) translateX(var(--move-left));
      opacity: 1;
    }

    .cta-text {
      transform-origin: left;
      transform: translateX(var(--move-left));
    }
  }
}
</style>
